// src/styles/theme.ts
export const theme = {
  colors: {
    primary: '#070709',
    secondary: '#0e0e12',
    accent: '#8b5cf6',
    accentDark: '#7c3aed',
    accentLight: '#a78bfa',
    accentGreen: '#22c55e',
    glass: 'rgba(255, 255, 255, 0.02)',
    glassBorder: 'rgba(255, 255, 255, 0.07)',
    light: '#94a3b8',
    dark: '#030305',
    white: '#f1f5f9',
    muted: '#64748b',
    success: '#22c55e',
    cardBg: '#0e0e12',
  },
  gradients: {
    accent: 'linear-gradient(135deg, #7c3aed 0%, #9b6cfc 100%)',
    accentHover: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)',
    accentFull: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 50%, #22c55e 100%)',
    card: 'linear-gradient(145deg, #0e0e12 0%, #0b0b0e 100%)',
    hero: 'radial-gradient(ellipse at 20% 60%, rgba(124,58,237,0.18) 0%, transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(34,197,94,0.07) 0%, transparent 50%)',
    background: 'linear-gradient(180deg, #070709 0%, #030305 100%)',
  },
  fonts: {
    main: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    code: "'JetBrains Mono', 'Fira Code', monospace",
  },
  shadows: {
    card: '0 1px 3px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.06)',
    glow: '0 0 25px rgba(139,92,246,0.12)',
    glowStrong: '0 0 50px rgba(139,92,246,0.18), 0 25px 60px rgba(0,0,0,0.5)',
    violet: '0 0 40px rgba(139,92,246,0.3)',
  },
};
